import React, { useEffect, useState, FC, FormEventHandler } from "react";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../utility/apiInstance";

const defaultTheme = createTheme();

const ForgetPassword: FC = () => {
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [token, setToken] = useState("");
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const urlToken = window.location.search.split("/")[1];
    setToken(urlToken || "");
  }, []);

  useEffect(() => {
    const verifyUserEmail = async () => {
      try {
        await axiosInstance.post("/api/v1/customers-auth/forgot-password", {
          token,
        });
        setVerified(true);
      } catch (error: any) {
        setError(true);
      }
    };

    if (token.length > 0) {
      verifyUserEmail();
    }
  }, [token]);

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();

    if (!isValidEmail(email)) {
      toast.error("Invalid email format.");
      return;
    }

    try {
      const response = await axiosInstance.post(
        "/api/v1/customers-auth/forgot-password",
        { email }
      );

      if (response.data.success) {
        setEmailSent(true);
      } else {
      }
    } catch (error) {
      toast.error("Invalid Email ID");
    }
  };

  const handleGoToLogin = () => {
    if (mounted) {
      navigate("/");
    }
  };

  return (
    <>
      <div className="sgateloginMain">
        <div className="sgateloginInner">
          <div className="sgLoginBox">
            <div className="sgLoginLeft">
              <div className="sgLoginLeftinn">
                <div className="sgLeftcontent">
                  <h1>
                    Welcome to <span className="blink">CargoDash</span>{" "}
                    Tracking!
                  </h1>

                  <p>
                    Your all-in-one solution for staying informed about your
                    shipment's progress. Receive intelligent notifications
                    through WhatsApp and Email. Begin tracking your shipment
                    today!
                  </p>
                </div>
                <figure className="slogintrack">
                  <img src="/images/sgate-track.png" alt="Track shipments" />
                  <div className="circle-ripple"></div>
                </figure>

                <i className="logoicon">
                  <img src="/images/sgate-icon.png" alt="SGATE icon" />
                </i>
              </div>
            </div>
            <div className="sgLoginRight">
              <div className="sgRightBox">
                <figure className="slogo">
                  <img src="/images/logo.png" alt="SGATE logo" />
                </figure>

                <div className="sgLoginTittle">
                  <article>
                    {" "}
                    <i>
                      <img src="/images/signicon.png" alt="Sign icon" />
                    </i>
                    <h3> Forgot Password</h3>
                  </article>
                  <p>
                    Enter your registered email ID to get a password reset link.
                  </p>
                </div>

                <div className="loginform">
                  <ThemeProvider theme={defaultTheme}>
                    <div className="forgotpasswordd">
                      <div className="forgotpasswordd2">
                        {!emailSent ? (
                          <>
                            <form onSubmit={handleSubmit}>
                              <div className="mb-4">
                                <TextField
                                  type="email"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="email"
                                  label="Email Address"
                                  name="email"
                                  autoComplete="email"
                                  value={email}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => setEmail(e.target.value)}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      "& fieldset": {
                                        borderColor: "#838285",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "#838285",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#838285",
                                      },
                                      "& .MuiInputBase-input": {
                                        color: "#838285",
                                      },
                                      "& .MuiOutlinedInput-root:hover .MuiInputBase-input":
                                        {
                                          color: "#fab800",
                                        },
                                      "& .MuiOutlinedInput-root.Mui-focused .MuiInputBase-input":
                                        {
                                          color: "#fab800",
                                        },
                                    },
                                    "& .MuiFormLabel-root": {
                                      color: "#838285",
                                    },
                                    "& .MuiFormLabel-root.Mui-focused": {
                                      color: "#fab800",
                                    },
                                  }}
                                />
                              </div>
                              <div className="logibbtn">
                                <button type="submit" className="btn btnTheme">
                                  Get Password Reset Link
                                </button>
                              </div>
                            </form>
                          </>
                        ) : (
                          <div className="emailtext">
                            <DoneAllIcon
                              className="text-yellow-500 mb-4"
                              fontSize="large"
                            />
                            <p className="textsent">
                              An email has been sent to your registered email
                              ID. Please reset your password and try logging in
                              again.
                            </p>
                            <div className="logibbtn btnC">
                              <button
                                onClick={handleGoToLogin}
                                className="btn btnTheme"
                              >
                                Go to Login Page
                              </button>
                            </div>{" "}
                          </div>
                        )}
                      </div>
                    </div>
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
